// extracted by mini-css-extract-plugin
module.exports = {"body":"ShopList_body__159im"};